import React, { useState } from "react";
import {
  AccordionContainer,
  AccordionHeader,
  AccordionContent,
  AccordionDetailContainer,
  ChevronIcon,
  AccordionLine,
} from "./Accordion.styles";
import { AccordionProps } from "./Accordion.types";
import {
  Body5MediumTypography,
  Body5RegularTypography,
} from "../../primitives/Typography/typographyVariants";

export const Accordion: React.FC<AccordionProps> = ({
  question,
  answer,
  accordionDetail,
  disabled = false,
  defaultOpen = false,
  backgroundColor,
  bottomLineColor,
}) => {
  const [isOpen, setIsOpen] = useState(defaultOpen);

  const toggleAccordion = () => {
    if (!disabled) setIsOpen(!isOpen);
  };

  return (
    <AccordionContainer
      isOpen={isOpen}
      disabled={disabled}
      backgroundColor={backgroundColor}
    >
      <AccordionHeader onClick={toggleAccordion}>
        <Body5MediumTypography>{question}</Body5MediumTypography>
        <ChevronIcon isOpen={isOpen} className="fa-solid fa-chevron-down" />
      </AccordionHeader>

      {isOpen && !disabled && (
        <AccordionContent>
          {answer && <Body5RegularTypography>{answer}</Body5RegularTypography>}
          {accordionDetail && (
            <AccordionDetailContainer>
              {accordionDetail}
            </AccordionDetailContainer>
          )}
        </AccordionContent>
      )}
      <AccordionLine lineColor={bottomLineColor} />
    </AccordionContainer>
  );
};
